import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

const FORALogomark = ({ size = 'md', tone = 'copper', animated = false, className }) => {
  const [showCircles, setShowCircles] = useState(!animated);
  const [visibleCircles, setVisibleCircles] = useState(animated ? [] : [0, 1, 2, 3]);

  const sizeConfig = {
    sm: { container: 32, circle: 6, gap: 4 },
    md: { container: 40, circle: 8, gap: 4 },
    lg: { container: 56, circle: 10, gap: 6 },
    xl: { container: 76, circle: 14, gap: 8 }
  };

  const config = sizeConfig[size];

  const toneGradient = {
    copper: 'linear-gradient(135deg, #D4784A 0%, #B5612E 100%)',
    white:  'linear-gradient(135deg, #FFFFFF 0%, #F4ECE0 100%)',
  }[tone] || 'linear-gradient(135deg, #D4784A 0%, #B5612E 100%)';

  useEffect(() => {
    if (animated) {
      setShowCircles(true);
      // Animate circles one by one: top-left, top-right, bottom-right, bottom-left
      const order = [0, 1, 3, 2];
      order.forEach((index, i) => {
        setTimeout(() => {
          setVisibleCircles(prev => [...prev, index]);
        }, i * 80);
      });
    }
  }, [animated]);

  return (
    <div 
      className={cn('relative inline-flex', className)}
      style={{ 
        width: `${config.container}px`, 
        height: `${config.container}px` 
      }}
    >
      <div className="grid grid-cols-2 gap-0 w-full h-full" style={{ gap: `${config.gap}px` }}>
        {[0, 1, 2, 3].map((index) => (
          <div
            key={index}
            className={cn(
              'rounded-full transition-all',
              showCircles && visibleCircles.includes(index) ? 'animate-scale-in' : 'opacity-0 scale-0'
            )}
            style={{
              width: `${config.circle}px`,
              height: `${config.circle}px`,
              background: toneGradient,
              animationDelay: animated ? '0ms' : '0ms',
              animationDuration: '400ms',
              animationFillMode: 'both',
              animationTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)'
            }}
          />
        ))}
      </div>
    </div>
  );
};

FORALogomark.displayName = 'FORALogomark';

export { FORALogomark };